export const sortPriceResaleScript = `
    def priority_sort;
    priority_sort = false;
    if (!doc['priority_sort.keyword'].empty){
        priority_sort = true;
    }
    if (!doc['agent_marketing_level.keyword'].empty && doc['agent_marketing_level.keyword'].value ==~ /Enhanced/i){
        priority_sort = true;
    }
    if (!doc['broker_marketing_level.keyword'].empty && doc['broker_marketing_level.keyword'].value ==~ /Enhanced/i){
        priority_sort = true;
    }
    if (!doc['showcase_home.keyword'].empty && doc['showcase_home.keyword'].value ==~ /on/i){
        priority_sort = true;
    }
    if (!doc['property.keyword'].empty && doc['property.keyword'].value ==~ /^.*adpay$/i){
        priority_sort = true;
    }
    if ((_score > 1) && (priority_sort)){
        if (params.order == "desc") { return 100000000 * doc['price'].value }
        if (params.order == "asc") { return doc['price'].value/100000000 }
    }
    if ((_score > 1) && (!priority_sort)){
        if (params.order == "desc") { return 1000 * doc['price'].value }
        if (params.order == "asc") { return doc['price'].value/1000 }
    }
    if (_score == 1){
        if (params.order == "desc") { return doc['price'].value/1000 }
        if (params.order == "asc") { return 1000 * doc['price'].value }
    }
    if (_score < 1){
        if (params.order == "desc") { return doc['price'].value/100000000 }
        if (params.order == "asc") { return 100000000 * doc['price'].value }
    }
`

export const sortPriceRentalsScript = `
    def priority_sort;
    def priority_value;
    priority_sort = false;
    if (!doc['priority_sort_exists'].empty) {
        priority_value = doc['priority_sort_exists'].value
    }
    if (priority_value == 1){
        priority_sort = true;
    }
    if ((_score > 1) && (priority_sort)){
            if (params.order == "desc") { return 100000000 * doc['price'].value }
            if (params.order == "asc") { return doc['price'].value/100000000 }
    }
    if ((_score > 1) && (!priority_sort)){
            if (params.order == "desc") { return 1000 * doc['price'].value }
            if (params.order == "asc") { return doc['price'].value/1000 }
    }
    if (_score == 1){
            if (params.order == "desc") { return doc['price'].value/1000 }
            if (params.order == "asc") { return 1000 * doc['price'].value }
    }
    if (_score < 1){
            if (params.order == "desc") { return doc['price'].value/100000000 }
            if (params.order == "asc") { return 100000000 * doc['price'].value }
    }
`

export const sortRentMinScript = `
    if (_score >= 1){ return 1000 * doc['rent_min'].value }
    if (_score < 1){ return doc['rent_min'].value/1000 }
`

export const sortBathsScript = `
    def baths;
    baths = 0.0;
    if (! doc['baths'].empty) { baths = doc['baths'].value }
    if (_score > 1){
      if (params.order == "desc") { return 100.0 + baths }
      if (params.order == "asc") { return baths / 1000.0 }
    }
    if (_score == 1){
      if (params.order == "desc") { return 1.0 + baths }
      if (params.order == "asc") { return baths / 100.0 }
    }
    if (_score < 1){
      if (params.order == "desc") { return (baths + _score) / 100.0 }
      if (params.order == "asc") { return _score + baths + 1 }
    }
`
export const sortBedsScript = `
    def beds;
    beds = 0.0;
    if (! doc['beds'].empty) { beds = doc['beds'].value }
    if (_score > 1){
      if (params.order == "desc") { return 100.0 + beds }
      if (params.order == "asc") { return beds / 1000.0 }
    }
    if (_score == 1){
      if (params.order == "desc") { return 1.0 + beds }
      if (params.order == "asc") { return beds / 100.0 }
    }
    if (_score < 1){
      if (params.order == "desc") { return (beds + _score) / 100.0 }
      if (params.order == "asc") { return _score + beds + 1 }
    }
`

export const scoreScript = `return _score;`